import React from 'react'

import { useCart } from '@/entities/cart'

import { BasketContent } from './ui/basket-content/basket-content'
import { EmptyBasketContent } from './ui/empty-basket-content/empty-basket-content'
import { SkeletonLoader } from './ui/skeleton-loader/skeleton-loader'

export interface BasketProps {
	isRedirectedFromRegion: boolean
}

export const Basket = ({ isRedirectedFromRegion }: BasketProps): JSX.Element => {
	const { cartCount, isInit } = useCart()

	if (!isInit) {
		return <SkeletonLoader />
	}

	if (cartCount) {
		return <BasketContent showAlert={isRedirectedFromRegion} />
	}

	return <EmptyBasketContent />
}
